import * as Sentry from '@sentry/vue'

const PRODUCTION = 'production'
const STAGING = 'staging'
const DEVELOPMENT = 'development'

// 在 staging compile 時 process.env.NODE_ENV 不為 staging
// 因此先由 browser hostname 作為 environment 的判斷依據
const environment = (() => {
  const hostname = window.location.hostname
  if (hostname === 'statementdog.com') {
    return PRODUCTION
  }
  if (/^\w+\.statementdog\.com/.test(hostname)) {
    return STAGING
  }

  return DEVELOPMENT
})()

const initSentry = ({ app, router } = { app: undefined, router: undefined }) => {
  if (window._statementdog_global_variable_.sentryDisable) { return }
  if (environment === PRODUCTION || environment === STAGING) {
    const sentryConfig = {
      app,
      tracesSampleRate: environment === PRODUCTION ? 0.3 : 1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.3,
      dsn: 'https://78ceb91faa50443fbc1127429dec792a@o19314.ingest.sentry.io/5317636',
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
        }),
      ],

      // 確保只有在我們自己網站的錯誤才會被送到 Sentry，第三方的錯誤不會被送到 Sentry
      tracePropagationTargets: ['localhost', 'hotdog.test', 'statementdog.com', /^\//],
      environment,
    }

    if (router !== undefined) {
      sentryConfig.integrations.push(
        Sentry.browserTracingIntegration({
          router,
          enableInp: true,
        }),
      )
    } else {
      sentryConfig.integrations.push(
        Sentry.browserTracingIntegration(),
      )
    }

    if (app === undefined) {
      delete sentryConfig.app
    }

    Sentry.init(sentryConfig)
  }
}

Sentry.setUser({
  id: window._statementdog_global_variable_.currentUser.id,
  email: window._statementdog_global_variable_.currentUser.email,
  roles: window._statementdog_global_variable_.currentUser.roles,
})

export default initSentry
